import { css } from '@utils/css';
import { units } from '../units.js';

const hr = css`
  margin: 0;
  height: ${units.px(1)};
  border: none;
`;

export { hr };
//# sourceMappingURL=hr.js.map
